module.exports = __webpack_public_path__ + "img/item_galaxy_watch.e13a2c8b.jpg";